export default "__VITE_ASSET__Dpje_ORW__"